import { render, staticRenderFns } from "./commonStep.vue?vue&type=template&id=3818d0e0&scoped=true"
import script from "./commonStep.vue?vue&type=script&lang=js"
export * from "./commonStep.vue?vue&type=script&lang=js"
import style0 from "./commonStep.vue?vue&type=style&index=0&id=3818d0e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3818d0e0",
  null
  
)

export default component.exports